import { IBaseInfo } from "../store"

export type IPersonalInfo = IBaseInfo & {
    'passport': string    
};

export enum PERSONAL_INFO_ACTION_TYPE {    
    INFO_SELECT = 'personal-info/info-select',
    INFO_RESET = 'personal-info/info-reset'    

};

export type IPersonalInfoState = {
    selected: IPersonalInfo | undefined  
};

function getPersonalInfoInitialState(): IPersonalInfoState {
    return {
        selected: undefined        
    };
}

export function personalInfoReducer(state = getPersonalInfoInitialState(), action: {type: PERSONAL_INFO_ACTION_TYPE, payload: any}) {
    switch (action.type) {
        case PERSONAL_INFO_ACTION_TYPE.INFO_SELECT:
            return {...state, selected: action.payload};
        case PERSONAL_INFO_ACTION_TYPE.INFO_RESET:
                return {...state, selected: undefined};        
        default:
            return state;
    }
}